export const rol_captura_notifica = [
    "OBSERVADORES15.ADMIN.PARAM.CAPTURA.OC",
    "OBSERVADORES15.ADMIN.CAPTURA.OC",
];

export const rol_consulta_notifica = [
    "OBSERVADORES15.CONSULTA.OC",
    "OBSERVADORES15.CAU.OC", //Cau
];
